type EnvVariables = {
  REACT_APP_BASE_URL?: string;
  REACT_APP_NODE_ENV?: string;
  REACT_APP_IS_TELEMETRY_ENABLED?: string;
  REACT_APP_GTM_ID?: string;
  REACT_APP_GTM_AUTH?: string;
  REACT_APP_GTM_PREVIEW?: string;
  REACT_APP_FLASH_SCREEN_DELAY?: string;
};

declare global {
  interface Window {
    _env_: EnvVariables;
  }
}

const getEnvVar = (key: keyof EnvVariables, defaultValue = ''): string => {
  return window._env_ && window._env_[key] ? (window._env_[key] as string) : defaultValue;
};

export default getEnvVar;
